import React, { useState, useEffect } from 'react'
import { AntModal } from "components/AntComponents";
import { Button } from "antd";

export function DeleteModal({ title, subheading, onOk, onCancel, isOpen }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(!!isOpen);
    }, [isOpen])

    useEffect(() => {

    })

    return (
        <AntModal
            title={title}
            isOpen={isVisible}
            onClose={() => {
                setIsVisible(false);
            }}
        >
            <p>{subheading}</p>
            <div className="flex gap-10 mt-3 flex-row-reverse">
                <Button
                    type="default"
                    onClick={() => {
                        onCancel();
                        setIsVisible(false);
                    }}>Cancel</Button>
                <Button danger onClick={() => {
                    onOk();
                    setIsVisible(false)
                }}>Ok</Button>
            </div>
        </AntModal>
    )
}
